import {IHttpProvider, IHttpResponse, IQService, IRootScopeService} from "angular";
import {AuthEvents} from "./security-module";

export default function authFailed($httpProvider: IHttpProvider) {
    $httpProvider.interceptors.push(authFailedInterceptor);
}

function authFailedInterceptor($rootScope: IRootScopeService, $q: IQService, AUTH_EVENTS: AuthEvents) {
    return {
        responseError(rejection: IHttpResponse<any>) {
            if (rejection.status == 401) {
                $rootScope.$broadcast(AUTH_EVENTS.AUTH_FAILED);
            }
            return $q.reject(rejection);
        }
    };
}

authFailed.$inject = ['$httpProvider'];
authFailedInterceptor.$inject = ['$rootScope', '$q', 'AUTH_EVENTS'];
